export default {
  PROTOCOL: "https",
  API_VERSION: "v2",
  UZ_HOST: "uztvplus.uz",
  DEV_UZ_HOST: "v1.uztvplus.uz",
  TV_HOST: "mdby.tv",
  DEV_TV_HOST: "v1.mediabay.tv",
  UZ_API_ENDPOINT: "api.uztvplus.uz",
  DEV_UZ_API_ENDPOINT: "api.v1.uztvplus.uz",
  TV_API_ENDPOINT: "api.uztvplus.uz",
  DEV_TV_API_ENDPOINT: "api.v1.mdby.tv",
};
